import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"

const Banner = ({ image }) => (
	<div className='banner w-100 ratio-4-1 m-ratio-1-1 pos-rel overflow'>
		<GatsbyImage className='bg-image' image={image.gatsbyImageData} alt=""/>
	</div>
)

export default Banner
